import View from '@/components/atomic/atoms/layout/view/styled';
import styled from '@emotion/styled';

const MobileWrapper = styled(View)(({ theme }) => ({
	backgroundColor: theme.colors.primaryNavBackground,
	'> .swiper': {
		height: '100%',
		'> .swiper-wrapper': {
			height: '100%',
			'> .swiper-slide': {
				minHeight: '100%',
				':before': {
					content: '""',
					backgroundColor: theme.colors.primaryNavBackground,
					position: 'absolute',
					top: 0,
					left: 0,
					width: '100%',
					height: '100%',
					zIndex: -1,
				},
			},
		},
	},
	'#subnav-bar-fade-swiper .swiper-slide:not(.swiper-slide-active)': {
		visibility: 'hidden',
	},
}));

MobileWrapper.defaultProps = {
	$position: 'absolute',
	$left: 0,
	$top: 0,
	$width: '100%',
	$height: '100%',
	$display: 'block',
};

export default MobileWrapper;
